import { createAction, createReducer } from "redux-act";
import undoable from "redux-undo";
import { Positions, resetGeometryEditor, setGeometryEditor } from "../geometryEditor/geometryEditor";
import { reducerRegistry } from "../reducerRegistry";
import { resetSelectedFeatures } from "../selectFeatures/selectFeatures";
import { FeatureAttribute } from "../../modules/FeatureCard/components/Attributes/FeatureAttributeField";
import { UpdateAttributesPayload } from "./types";

export type EditFeatureState = {
  geometry?: Positions;
  attributes?: FeatureAttribute[];
};

export const reducerName = "editFeature";

const initialState: EditFeatureState = {};

export const undoEditFeature = createAction("edit-feature/undo");
export const redoEditFeature = createAction("edit-feature/redo");
export const resetEditFeatureChanges = createAction<boolean | void>("edit-feature/reset-edit-feature-changes");
export const resetChangeHistory = createAction("edit-feature/reset-history");
export const setAttributes = createAction<FeatureAttribute[]>("edit-feature/set-attributes");
export const setEditFeatureGeometry = createAction<Positions>("edit-feature/set-geometry");
export const unitEditFeatureGeometry = createAction<Positions>("edit-feature/unit-geometry");
export const subtractEditFeatureGeometry = createAction<Positions>("edit-feature/subtract-geometry");
export const updateAttributesForNewFeature = createAction<UpdateAttributesPayload>(
  "edit-feature/update-attributes-new-feature",
);

export const baseReducer = createReducer({}, initialState);

export const reducer = undoable(baseReducer, {
  undoType: undoEditFeature.getType(),
  redoType: redoEditFeature.getType(),
  limit: 10,
  ignoreInitialState: true,
  syncFilter: true,
  filter(action, currentState, { present }) {
    const geometryChanges = currentState.geometry !== present.geometry;
    const attributeChanges = currentState.attributes !== present.attributes;

    return !!present.geometry && !!present.attributes && (geometryChanges || attributeChanges);
  },
  clearHistoryType: resetChangeHistory.getType(),
});

baseReducer.on(setAttributes, (state, attributes) => ({ ...state, attributes }));
baseReducer.on(setGeometryEditor, (state, { geometry }) => ({ ...state, geometry }));
baseReducer.on(resetGeometryEditor, ({ attributes }) => ({ attributes }));
baseReducer.on(resetSelectedFeatures, () => initialState);
baseReducer.on(setEditFeatureGeometry, (state, geometry) => ({ ...state, geometry }));

reducerRegistry.register(reducerName, reducer);
